angular.module("eCareVault.common.mugshot", []);
